import { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { getContactosCliente, enviarCotizacionMayorista, finalizarCotizacion } from '../../../../service/AffariService';
import { validarEmail } from '../../../../utilities/validationUtils';
import LoaderTransparent from '../../../../components/ui/LoaderTransparent';



const EnviarDialog = ({ visible, onCancel, codigo, idCotizacion, descuentoTotal = 0 }) => {
    const [contactos, setContactos] = useState([]);
    const [selectedContactos, setSelectedContactos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [otro, setOtro] = useState('');
    const toast = useRef(null);

    useEffect(() => {
        if (!visible || !codigo) return;

        setLoading(true);
        setContactos([]);
        getContactosCliente(codigo)
            .then((resp) => {
                const lista = Array.isArray(resp) ? resp : resp?.contactos || [];
                setContactos(lista);
            })
            .catch((error) => {
                console.error('Error obteniendo contactos del cliente:', error);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Enviar cotización',
                        detail: 'No se pudieron cargar los contactos',
                        life: 3000,
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [visible, codigo]);

    const handleEnviar = async () => {
        if (!idCotizacion) {
            if (toast.current) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Enviar cotización',
                    detail: 'ID de cotización no disponible',
                    life: 3000,
                });
            }
            return;
        }

        const seleccionados = Array.isArray(selectedContactos) ? selectedContactos : [];

        const contactosSinCorreo = seleccionados.filter((c) => {
            const correo = c.email || c.correo;
            return !correo || String(correo).trim() === '';
        });

        if (contactosSinCorreo.length > 0) {
            if (toast.current) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Enviar cotización',
                    detail: 'Los contactos seleccionados deben tener correo electrónico.',
                    life: 3000,
                });
            }
            return;
        }

        const destinos = seleccionados
            .map((c) => c.id)
            .filter((v) => v != null && String(v).trim() !== '');

        const otros = (otro || '').trim();

        if (otros && !validarEmail(otros)) {
            if (toast.current) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Enviar cotización',
                    detail: 'Ingrese un correo válido en el campo "Otro correo".',
                    life: 3000,
                });
            }
            return;
        }

        if (!destinos.length && !otros) {
            if (toast.current) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Enviar cotización',
                    detail: 'Seleccione al menos un contacto o ingrese un correo adicional',
                    life: 3000,
                });
            }
            return;
        }

        try {
            setLoading(true);

            await finalizarCotizacion(idCotizacion, descuentoTotal, '');
            await enviarCotizacionMayorista(idCotizacion, destinos, otros);

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Enviar cotización',
                    detail: 'Cotización enviada correctamente',
                    life: 3000,
                });
            }
            if (onCancel) onCancel();
        } catch (error) {
            console.error('Error enviando cotización mayorista:', error);
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Enviar cotización',
                    detail: 'No se pudo enviar la cotización',
                    life: 3000,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toast ref={toast} position="top-right" baseZIndex={4000} appendTo={document.body} />
            <Dialog
                header="Enviar cotización"
                visible={visible}
                className="p-fluid custom-dialog"
                modal
                onHide={onCancel}
                dismissableMask={true}
            >
                {loading && <LoaderTransparent coverParent overlayTint="transparent" />}

                <div className="mb-3">
                    <DataTable
                        value={contactos}
                        tableStyle={{ minWidth: '40rem' }}
                        size="small"
                        dataKey="id"
                        className="p-datatable-sm border-1 surface-border border-round"
                        showGridlines
                        stripedRows
                        selectionMode="checkbox"
                        selection={selectedContactos}
                        onSelectionChange={(e) => setSelectedContactos(e.value)}
                        emptyMessage={<div className="p-4">No hay contactos para este cliente</div>}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                        <Column field="email" header="Email" />
                        <Column field="nombre" header="Nombre" />
                    </DataTable>
                </div>

                <div className="mb-3">
                    <span className="text-600 text-sm block mb-1">Otro correo</span>
                    <InputText
                        type="email"
                        placeholder="otro correo"
                        className="p-inputtext-sm w-full"
                        value={otro}
                        onChange={(e) => setOtro(e.target.value)}
                    />
                </div>

                <div className="flex justify-content-end gap-2 mt-3">
                    <Button
                        label="Enviar"
                        className="p-button-success p-button-sm"
                        icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-send'}
                        onClick={handleEnviar}
                        disabled={loading}
                    />
                </div>
            </Dialog>
        </>
    );
};

export default EnviarDialog;
